const translations = {
    fieldApplication: 'Field Application',
    flatFee: 'Flat Fee'
};

export default translations;
